import {Action, Selector, State, StateContext} from "@ngxs/store";
import {PaginationStateInterface} from "../models/pagination-state.interface";
import {Injectable} from "@angular/core";
import {RequestService} from "../services/request.service";
import {AppHelper} from "../helpers/app.helper";
import {PaginationAction} from "../actions/pagination-action";
import FetchPagination = PaginationAction.FetchPagination;
import FetchData = PaginationAction.FetchData;
import { CarteraService } from '../services/cartera.service';
import { OperacionSimboloInterface } from "../models/operacion-simbolo.interface";
import { PaginationInterface } from "../models/pagination.interface";

@State<PaginationStateInterface>({
  name: 'paginationData',
  defaults: {
    pagination: []
  }
})
@Injectable()
export class PaginationState {

  constructor(private requestService: RequestService, private carteraService: CarteraService) {
  }


  @Selector()
  static pagination(state: PaginationStateInterface) {

    return JSON.parse(JSON.stringify(state.pagination));
  }


  @Action(FetchData)
  async fetchData({getState, patchState}: StateContext<OperacionSimboloInterface>, action: FetchData){

    patchState({ ...getState(), ...{ data: action }  } );
     
  }


  @Action(FetchPagination)
  async fetchPagination({getState, patchState}: StateContext<PaginationStateInterface>, action: FetchPagination){

    patchState({ ...getState(), ... action } );

  }

}
